export * from './capitalize.pipe';
